// extracted by mini-css-extract-plugin
export default {"form":"AliasForm_form__gFo4F","field":"AliasForm_field__OyyWq","button":"AliasForm_button__C0pHA"};